/**
 * Creates a mini-cart object from mini-cart data.
 *
 * To create a MiniCartDetails object from local storage data, use the getMiniCartDetailsFromLocalStorageData()
 * function.
 *
 * Used in general and onCartUpdated.js
 */
window.MiniCartDetails = function (miniCartData) {
    this.cartTotal = 0;
    this.cartItems = 0;
    this.cartGiftCodeAmount = 0;
    this.teacherScreenName = '';
    this.promoCode = '';
    this.isGiftPurchase = false;
    this.hasItems = false;
    this.includeMonthly = false;
    this.monthlyAmount = 0;

    if (miniCartData !== undefined && miniCartData != null && miniCartData !== '') {
        const obj = JSON.parse(decodeURIComponent(miniCartData));
        if (obj.teacherScreenName) {
            this.teacherScreenName = obj.teacherScreenName;
        }
        if (obj.promoCode) {
            this.promoCode = obj.promoCode;
        }
        if (obj.isGiftPurchase) {
            this.isGiftPurchase = obj.isGiftPurchase;
        }
        this.proposalDonations = obj.proposalDonations;
        if (obj.cartGiftCodeAmount) {
            this.cartGiftCodeAmount = window.formatCurrency(obj.cartGiftCodeAmount);
            // The cartGiftCodeAmount cookie is also created from the gift code redemption page.
            // Maybe this can be changed so we rely only the MiniCartDetails property.
            window.createCookie('cartGiftCodeAmount', obj.cartGiftCodeAmount);
        }
        if (obj.cartItems) {
            this.cartItems = parseInt(obj.cartItems);
        }
        if (obj.cartTotal) {
            this.cartTotal = window.formatCurrency(obj.cartTotal);
        }
        if (obj.recurringDonation) {
            this.includeMonthly = true;
            this.monthlyAmount = obj.recurringDonation.donationAmount;
        }
    }

    this.hasItems = this.cartItems > 0;
};
